export default __webpack_public_path__ + "static/media/vilax-footer-texture-tile.01cc3a53.jpg";